import React, { useEffect, useState } from "react";
import { AiOutlineUnorderedList } from "react-icons/ai";
import { BiSearch } from "react-icons/bi";
import { BiCartDownload } from "react-icons/bi";

import "./QrMenuPage.css";
import { Link } from "react-router-dom";
import axios from "axios";
import { setLocalData, getLocalData } from "../../Services/localstoragedata";
import ShowOrders from "../ShowOrdersModal/ShowOrders";

const QrManuPage = ({ subCatas }) => {
  const [mainCategories, setMainCategories] = useState([]);
  const [cataTypes, setCataTypes] = useState([]);
  const [subCata, setSubCata] = useState([]);
  const [itemMaster, setItemMaster] = useState([]);
  const storedItems = JSON.parse(localStorage.getItem("outletdataLocal")) || [];
  const custId =
    JSON.parse(localStorage.getItem("loginDetails"))?.customerId || null;
  console.log("custid:", custId);

  const GuestHouseId = localStorage.getItem("guestHouseId");
  const TableNumber = localStorage.getItem("QRTableNo")
 const outletIsOpen =
  Array.isArray(storedItems?.data) && storedItems.data.length > 0
    ? storedItems.data[0].isOpen
    : false;



  console.log("storedItems:", storedItems);


  const cleanGuestHouseId = GuestHouseId ? GuestHouseId.replace(/\D/g, "") : "";
  const cleanTableNumber = TableNumber ? TableNumber.replace(/\D/g, "") : "";

  let orderState = {};

if (cleanGuestHouseId > 0) {
  orderState.btntext = "Order Now";
  orderState.path = "/QrCartItemsGuestHouseParcel";  // guest → parcel
} else if (cleanTableNumber > 0) {
  orderState.btntext = "Order Now";
  orderState.path = "/QrCartItemsTableNo";  // dine-in by table
}else if (TableNumber == "Parcel") {
  orderState.btntext = "Order Now";
  orderState.path = "/QrCartItemsQuickParcel";  // dine-in by table
}
 else if (custId) {
  orderState.btntext = "Order Now";
  orderState.path = "/QrCartItems";  // dine-in
} else {
  orderState.btntext = "Login to Order";
  orderState.path = "/Login";  // no user info
}



  

  console.log("Check", orderState);

  useEffect(() => {
    setMainCategories(JSON.parse(localStorage.getItem("mainCategories")) || []); // Parse string to array
    setCataTypes(JSON.parse(localStorage.getItem("cataTypes")) || []);
    setSubCata(JSON.parse(localStorage.getItem("subCata")) || []);
    setItemMaster(getAvailableItems());
  }, []);

  function getAvailableItems() {
    const itemMaster = JSON.parse(localStorage.getItem("itemMaster")) || [];

    // Get current time in decimal format (e.g., 14.5 for 2:30 PM)
    const now = new Date();
    const currentTime = now.getHours() + now.getMinutes() / 60;

    const availableItems = itemMaster.filter((item) => {
        if (!item.isActive) return false; 
      const openTime = parseFloat(item.itemOpenTime); // e.g., "21.00" => 21
      const closeTime = parseFloat(item.itemCloseTime); // e.g., "03.00" => 3

      if (openTime <= closeTime) {
        // Normal case: open and close on the same day
        return currentTime >= openTime && currentTime <= closeTime;
      } else {
        // Overnight case: openTime > closeTime (e.g., 21.00 - 03.00)
        return currentTime >= openTime || currentTime <= closeTime;
      }
    });

    return availableItems;
  }

  const getLocalData = (key) => {
    try {
      const data = localStorage.getItem(key);
      return data ? JSON.parse(data) : null;
    } catch (error) {
      console.error("Error getting localStorage data", error);
      return null;
    }
  };

  const setLocalData = (key, value) => {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error("Error setting localStorage data", error);
    }
  };

  const [mainCategoryId, setMainCategoryId] = useState(1);

  const [selectedCataTypeId, setSelectedCataTypeId] = useState(99);
  const [activeAccordionIndex, setActiveAccordionIndex] = useState(null); // Track expanded accordion

  const API_BASE_URL = process.env.REACT_APP_API_KEY;

  const [selectedItems, setSelectedItems] = useState(
    getLocalData("selectedItems") || []
  );
  const [selectedItemsCount, setSelectedItemsCount] = useState(
    selectedItems.length
  );

  const totals = selectedItems.reduce(
    (acc, item) => {
      acc.totalQty += item.Qty;
      acc.totalAmount += item.Amount;
      return acc;
    },
    { totalQty: 0, totalAmount: 0 }
  );

  const uniqueSubCataIds = [
    ...new Set(selectedItems.map((item) => item.subCataId)),
  ];

  const handleQtyChange = (item, change) => {
    const updatedItemMaster = itemMaster.map((itm) => {
      if (itm.qrItemId === item.qrItemId) {
        const newQty = (itm.Qty || 0) + change;
        const updatedQty = newQty >= 0 ? newQty : 0;
        return { ...itm, Qty: updatedQty };
      }
      return itm;
    });

    setItemMaster(updatedItemMaster);

    const updatedItem = updatedItemMaster.find(
      (itm) => itm.qrItemId === item.qrItemId
    );
    const rate =
      updatedItem.rateApply === 0 ? 0 : parseFloat(updatedItem.rateApply); // Handle "APS" if needed

    let updatedSelectedItems = [...selectedItems];

    if (updatedItem.Qty > 0) {
      const existingIndex = selectedItems.findIndex(
        (itm) => itm.qrItemId === updatedItem.qrItemId
      );
      const selectedItemData = {
        outletId: outletId,
        rmsItemId: updatedItem.rmsItemId,
        qrItemId: updatedItem.qrItemId,
        qrItemName: updatedItem.qrItemName,
        ApplayRate: rate,
        Qty: updatedItem.Qty,
        Amount: updatedItem.Qty * rate,
        subCataId: updatedItem.subCataId,
      };

      if (existingIndex >= 0) {
        updatedSelectedItems[existingIndex] = selectedItemData;
      } else {
        updatedSelectedItems.push(selectedItemData);
      }
    } else {
      updatedSelectedItems = selectedItems.filter(
        (itm) => itm.qrItemId !== updatedItem.qrItemId
      );
    }

    setSelectedItems(updatedSelectedItems);
    setLocalData("selectedItems", updatedSelectedItems);
    setSelectedItemsCount(updatedSelectedItems.length);
  };

  const clearSelectedItems = () => {
    const resetItems = itemMaster.map((item) => ({ ...item, Qty: 0 }));
    setItemMaster(resetItems);
    setSelectedItems([]);
    setSelectedItemsCount(0);
    setLocalData("selectedItems", []);
    console.log("Selected items cleared!");
  };

  useEffect(() => {
    const localSelectedItems = getLocalData("selectedItems") || [];

    if (localSelectedItems.length > 0 && itemMaster.length > 0) {
      const updatedItemMaster = itemMaster.map((item) => {
        const matchedLocalItem = localSelectedItems.find(
          (localItem) => localItem.qrItemId === item.qrItemId
        );

        if (matchedLocalItem) {
          return {
            ...item,
            Qty: matchedLocalItem.Qty,
            Amount: matchedLocalItem.Amount,
          };
        }
        return item;
      });

      setItemMaster(updatedItemMaster);
      setSelectedItems(localSelectedItems);
      setSelectedItemsCount(localSelectedItems.length);
    }
  }, [itemMaster.length]);

  useEffect(() => {
    const localSelectedItems = getLocalData("selectedItems") || [];

    if (localSelectedItems.length > 0 && itemMaster.length > 0) {
      const updatedItemMaster = itemMaster.map((item) => {
        const matchedLocalItem = localSelectedItems.find(
          (localItem) => localItem.qrItemId === item.qrItemId
        );

        if (matchedLocalItem) {
          return {
            ...item,
            Qty: matchedLocalItem.Qty,
            Amount: matchedLocalItem.Amount,
          };
        }
        return item;
      });

      setItemMaster(updatedItemMaster);
      setSelectedItems(localSelectedItems);
      setSelectedItemsCount(localSelectedItems.length);
    }
  }, [itemMaster.length]);

  const handleCategoryClick = (id) => {
    setMainCategoryId(id);
  
    if (id > 1) {
      setSelectedCataTypeId(0);
    } else if (id === 1 && selectedCataTypeId !== 1) {
      setSelectedCataTypeId(1);
    }
  
    setActiveAccordionIndex(null); // Collapse all
  };
  

  const toggleAccordion = (index) => {
    setActiveAccordionIndex((prevIndex) => (prevIndex == index ? null : index));
  };

  const handleCataTypeClick = (cataTypeId) => {
    setSelectedCataTypeId(cataTypeId);
  };


  useEffect(() => {
    if (mainCategoryId === 1 && selectedCataTypeId !== 99) {
      handleCataTypeClick(99); // simulate click
    } else if (mainCategoryId !== 1) {
      setSelectedCataTypeId(0); // reset for other categories
    }
  }, [mainCategoryId]);
  

const cached = JSON.parse(localStorage.getItem("outletdataLocal")) || {};
const storedData = cached.data || []; // get the actual array

let outletId, outletlogo;

if (Array.isArray(storedData) && storedData.length > 0) {
  outletId = storedData[0].outletId;
  outletlogo = storedData[0].outletlogo;
} else if (storedData && typeof storedData === "object") {
  outletId = storedData.outletId;
  outletlogo = storedData.outletlogo;
}


  // Debugging
  console.log("outletId:", outletId);
  console.log("outletlogo:", outletlogo);

  localStorage.setItem("outletId:", outletId);

  return (
    <>
      <div className="container-fluid">
        <div className="col-md-12">
          <div className="row">
            <nav className="navbar navbar-light bg-light sticky-top">
              <div className="container-fluid">
                <form className="d-flex">
                  <b className="navbar-brand me-3">
                    <img src={outletlogo} width={60} height={40} alt="" />
                  </b>
                </form>
              </div>
            </nav>

            <div
              className="d-flex flex-nowrap overflow-scroll "
              style={{
                scrollbarWidth: "none", // For Firefox
                msOverflowStyle: "none", // For Internet Explorer and Edge
              }}
            >
              {mainCategories.map((category) => (
                <div
                  className="card me-2 MainCataCardStyle"
                  key={category.id}
                  onClick={() => handleCategoryClick(category.mainCataId)}
                >
                  <img
                    src={category.mainCataImage}
                    className="card-img-top MenuImageStyle"
                    alt={category.mainCataName}
                  />
                  <div
                    className="card-body text-center"
                    style={{
                      height: "8px",
                      overflow: "hidden",
                      fontSize: "15px",
                      lineHeight: "1px",
                    }}
                  >
                    <b className="card-title">{category.mainCataName}</b>
                  </div>
                </div>
              ))}
            </div>

            {mainCategoryId === 1 && (
              <div className="mt-2 cataTypeContainer">
                {/* "99" button dynamically using first cataType's cataTypeId */}
                {cataTypes.length > 0 && (
                 <button
                 className={`btn cataTypeBtn me-2 ${
                   selectedCataTypeId === 99 ? "btn-primary" : "btn-outline-primary"
                 }`}
                 onClick={() => handleCataTypeClick(99)}
               >
                 All
               </button>
                )}

                {/* Rest of cataTypes */}
                {cataTypes.map((cataType) => (
                  <button
                    className="btn btn-outline-primary cataTypeBtn"
                    key={cataType.id}
                    onClick={() => handleCataTypeClick(cataType.cataTypeId)}
                  >
                    <span className="cataTypeName">
                      {cataType.cataTypeName}
                    </span>
                  </button>
                ))}
              </div>
            )}

            {mainCategoryId && (
              <div className="accordionScroll">
                <div className="accordion mt-2" id="accordionParent">
                  {subCata
                    .filter(
                      (subCataItem) => subCataItem.mainCataId == mainCategoryId
                    ) // Filter by mainCategoryId
                    .filter((subCataItem) =>
                      itemMaster.some(
                        (item) =>
                          item.subCataId == subCataItem.subCataId &&
                          (selectedCataTypeId != 99
                            ? item.cataTypeId == selectedCataTypeId ||
                              item.cataTypeId == 0
                            : item.cataTypeId != 99)
                      )
                    )
                    // Filter by mainCategoryId
                    .map((subCatas, index) => {
                      const isHighlighted = uniqueSubCataIds.includes(
                        subCatas.subCataId
                      ); // Check if in list

                      return (
                        <div className="accordion-item" key={index}>
                          <h2
                            className="accordion-header"
                            id={`heading-${index}`}
                          >
                            <button
                              className={`accordion-button subcataAccBtn ${
                                activeAccordionIndex === index
                                  ? ""
                                  : "collapsed"
                              }`}
                              type="button"
                              // data-bs-toggle="collapse"
                              // data-bs-target={`#collapse-${index}`}
                              onClick={() => toggleAccordion(index)}
                              aria-expanded={activeAccordionIndex === index}
                              aria-controls={`collapse-${index}`}
                              style={{
                                backgroundColor: isHighlighted ? "pink" : "", // Set pink if matched
                              }}
                              // onClick={() => handleCataTypeClick(0)}
                            >
                              {subCatas.subCataName}
                            </button>
                          </h2>
                          <div
                            id={`collapse-${index}`}
                            className={`accordion-collapse collapse ${
                              activeAccordionIndex === index ? "show" : ""
                            }`}
                            aria-labelledby={`heading-${index}`}
                            data-bs-parent="#accordionParent"
                          >
                            <div className="accordion-body bodyCss">
                              {/* Filter and display items based on subCataId */}
                              {itemMaster
                                .filter(
                                  (item) =>
                                    item.subCataId == subCatas.subCataId &&
                                    // Match subCataId

                                    (selectedCataTypeId != 99
                                      ? item.cataTypeId == selectedCataTypeId ||
                                        item.cataTypeId == 0
                                      : item.cataTypeId != 99)
                                )

                                .map((filteredItem) => (
                                  <div key={filteredItem.id} className="item">
                                    <div
                                      className="d-flex"
                                      style={{ fontSize: "15px" }}
                                    >
                                      <h6 className="qrItemNameStyle">
                                        {filteredItem.qrItemName}
                                      </h6>

                                      <div className="selectedRateStyle me-2">
                                        {filteredItem.rateApply === 0
                                          ? "APS"
                                          : filteredItem.rateApply}
                                      </div>
                                      {filteredItem.Qty > 0 && (
                                        <div
                                          className="qtybtn"
                                          style={{ backgroundColor: "pink" }}
                                          onClick={() =>
                                            handleQtyChange(filteredItem, -1)
                                          }
                                        >
                                          -
                                        </div>
                                      )}

                                      <div
                                        className="qtybtn"
                                        style={{ fontSize: "16px" }}
                                      >
                                        {filteredItem.Qty || 0}
                                      </div>

                                      <div
                                        className="qtybtn"
                                        style={{
                                          backgroundColor: "lightgreen",
                                        }}
                                        onClick={() =>
                                          handleQtyChange(filteredItem, 1)
                                        }
                                      >
                                        +
                                      </div>
                                      {filteredItem.Qty > 0 && (
                                        <div
                                          className="qtybtn"
                                          style={{
                                            width: "50px",
                                            backgroundColor: "white",
                                            fontSize: "15px",
                                            border: "none",
                                          }}
                                        >
                                          <b>
                                            {filteredItem.Qty &&
                                            filteredItem.rateApply !== 0
                                              ? filteredItem.Qty *
                                                filteredItem.rateApply
                                              : 0}
                                          </b>
                                        </div>
                                      )}
                                    </div>

                                    {filteredItem.qrItemDescription1 ||
                                      filteredItem.qrItemDescription2 ||
                                      (filteredItem.qrItemDescription3 && (
                                        <div className="pb-2 dscrstyle">
                                          {[
                                            filteredItem.qrItemDescription1,
                                            filteredItem.qrItemDescription2,
                                            filteredItem.qrItemDescription3,
                                          ]
                                            .filter((desc) => desc) // Filter out empty descriptions
                                            .map((desc, i) => (
                                              <div key={i}>{desc}</div>
                                            ))}
                                        </div>
                                      ))}
                                  </div>
                                ))}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>
            )}
            <div className="row d-flex fixed-bottom">
              <div className="col-3 ">
        <Link
  to={
    outletIsOpen && selectedItemsCount > 0
      ? orderState.path
      : "#"
  }
  onClick={(e) => {
    if (!outletIsOpen || selectedItemsCount === 0) {
      e.preventDefault(); // stop link click
      return;
    }
    localStorage.setItem("backPaath", "/QrCartItems");
  }}
>
  <button
    className="btn btn-success orderbtnCss"
    style={{ width: "100px" }}
    disabled={!(outletIsOpen && selectedItemsCount > 0)}
  >
    {orderState.btntext}
  </button>
</Link>



              </div>
              <div className="col-6 p-0">
                <div className="d-flex justify-content-center">
                  <table className="border tblOrder">
                    <thead>
                      <tr className="border">
                        <th className="border">Items</th>
                        <th className="border">Qty</th>
                        <th className="border">Amount</th>
                      </tr>
                    </thead>
                    <tbody className="tblOrder">
                      <tr className="border">
                        <td className="border">{selectedItemsCount}</td>
                        <td className="border">{totals.totalQty}</td>
                        <td className="border">₹{totals.totalAmount}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="col-3 p-1">
                <ShowOrders />
                <button
                  className="btn btn-danger showbtnCss"
                  onClick={clearSelectedItems}
                >
                  Clear Cart
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default QrManuPage;
